import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { createElement } from 'react';

const catalogGridPage = catalogPlugin.getExtension('page:catalog').override({
  params: {
    loader: async () => {
      const { CatalogGridPage } = await import(
        './components/CatalogGridPage/CatalogGridPage'
      );
      return createElement(CatalogGridPage);
    },
  },
});

export const catalogGridModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [catalogGridPage],
});
